import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTheme } from '../../contexts/ThemeContext';
import Layout from '../Layout';

const TermsPage = () => {
  const { t, language } = useLanguage();
  const { isDark } = useTheme();

  // Direct inline style for title color
  const titleStyle = {
    fontWeight: 700,
    color: isDark ? '#0ea5e9' : '#6b21a8' // sky-500 for dark, purple-800 for light
  };

  return (
    <Layout>
      <div className="space-y-6">
        <Helmet>
          <title>{language === 'zh' ? '使用條款 | Beat Buddy 節拍器' : 'Terms of Use | Beat Buddy Metronome'}</title>
          <meta name="description" content={language === 'zh' ? "了解使用 Beat Buddy 節拍器應用的條款和條件。我們的使用條款概述了您使用本應用時的權利和責任。" : "Understand the terms and conditions for using the Beat Buddy metronome app. Our Terms of Use outline your rights and responsibilities when using this application."} />
          <meta name="keywords" content="Beat Buddy, terms of use, user agreement, service terms, legal terms, metronome app" />
          <link rel="canonical" href="https://beatbuddy.app/terms" />
        </Helmet>

        <div className="text-center max-w-xl mx-auto">
          <h2 className="text-3xl mb-2">
            <span style={titleStyle}>{t('termsTitle')}</span>
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 mx-auto">
            {t('termsSubtitle')}
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-3xl p-6 shadow-xl">
          <div className="prose prose-lg dark:prose-invert max-w-none">
            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('acceptanceOfTerms')}</h3>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              {t('acceptanceText1')}
            </p>
            <p className="mb-8 text-gray-700 dark:text-gray-300">
              {t('acceptanceText2')}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('usageLicense')}</h3>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              {t('usageLicenseText1')}
            </p>
            <p className="mb-8 text-gray-700 dark:text-gray-300">
              {t('usageLicenseText2')}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('userContent')}</h3>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              {t('userContentText1')}
            </p>
            <p className="mb-8 text-gray-700 dark:text-gray-300">
              {t('userContentText2')}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('intellectualProperty')}</h3>
            <p className="mb-8 text-gray-700 dark:text-gray-300">
              {t('intellectualPropertyText')}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('disclaimer')}</h3>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              {t('disclaimerText1')}
            </p>
            <p className="mb-8 text-gray-700 dark:text-gray-300">
              {t('disclaimerText2')}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('limitationOfLiability')}</h3>
            <p className="mb-8 text-gray-700 dark:text-gray-300">
              {t('limitationOfLiabilityText')}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('thirdPartyLinks')}</h3>
            <p className="mb-8 text-gray-700 dark:text-gray-300">
              {t('thirdPartyLinksText')}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('termination')}</h3>
            <p className="mb-8 text-gray-700 dark:text-gray-300">
              {t('terminationText')}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('changes')}</h3>
            <p className="mb-8 text-gray-700 dark:text-gray-300">
              {t('changesText')}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('governingLaw')}</h3>
            <p className="mb-8 text-gray-700 dark:text-gray-300">
              {t('governingLawText')}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('contactUsTerms')}</h3>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              {t('contactUsTermsText')}
            </p>
            <p className="text-gray-700 dark:text-gray-300">
              <strong className="text-gray-800 dark:text-gray-200">{t('email')}：</strong> info@homy.hk
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TermsPage;